export const PAGES = {
    'WELCOME': '/',
    'LOGIN': '/login',
    'REGISTRATION': '/registration',
    'RECOVERY': '/recovery',
    'CONFIRM_RECOVERY': '/confirm-recovery',
    'AUTH_MAGIC': '/auth-magic',
    'INVITATION': '/invite',
    'ONE_TIME_CODE': '/one-time-code',
    'ACCOUNT_DELETED': '/account-deleted',
    'QUESTIONS': '/questions',
    'ONBOARDING': '/onboarding',
    'LAST_STEP': '/last-step',
    'CONFIRMED': '/confirmed',
    'PROFILE': '/profile',
    'MY_COMMUNITIES': '/my_communities',
    'CONTACTS': '/contacts',
    'PARTICIPANTS': '/participants',
    'MENTORSHIP': '/mentorship',
    'EVENT': '/admin',
    'DASHBOARD': '/dashboard',
    'NOTIFICATIONS': '/notifications',
    'SETTINGS': '/settings',
    'SCORE_MATCH': '/score-match',
    'SUBSCRIPTIONS': '/subscriptions',
    'EVENT_LIST': '/events', // Add event list page route
    'EVENT_CREATE': '/event/create',
    'VACANCY_LIST': '/jobs', // Career tab — job list
    'VACANCY_CREATE': '/jobs/create',
    'VACANCY_DETAIL': '/job/:slug',
    'VACANCY_APPLY': '/job/:slug/apply',
    'VACANCY_APPLICATIONS': '/jobs/:slug/applications',
    'VACANCY_APPLICATION_DETAILS': '/jobs/:slug/applications/:applicationId',
    'VACANCY_QUESTION_MANAGER': '/job/:slug/questions',
    'FAQ': '/faq',
    'NAVBAR_PREVIEW': '/navbar-preview',
    'KRASAVA_REFERENCE': '/krasava-reference',
    'NOT_FOUND_PAGE': '/not-found',
    'CHATS': '/chats',
    'CHAT_DETAIL': '/chats/:chatId',
    'MANAGE_CHATS': '/manage-chats',
    'MANAGE_CHAT_CONVERSATIONS': '/manage-chats/conversations',
    'MANAGE_CHAT_SETTINGS': '/manage-chats/settings',
    'FULL_PARTICIPANT_VIEW': '/u/:slug',
    'ADMIN': '/admin',
    'ADMIN_COMMUNITY': '/admin/community',
    'ADMIN_ANALYTICS': '/admin/analytics',
    'ADMIN_NOTIFICATIONS': '/admin/notifications',
    'ADMIN_FAQ': '/admin/faq',
    'ADMIN_CONFERENCE_BUTTONS': '/admin/conference-buttons',
    'ADMIN_CHATS': '/admin/chats',
    'ADMIN_CHAT_CONVERSATIONS': '/admin/chats/conversations',
    'ADMIN_CHAT_SETTINGS': '/admin/chats/settings',
    'ADMIN_CHAT_SETTINGS_SCENARIOS': '/admin/chats/settings/scenarios',
    'ADMIN_CHAT_SETTINGS_TEMPLATES': '/admin/chats/settings/templates',
    'ADMIN_CHAT_SETTINGS_BOT': '/admin/chats/settings/bot',
    'ADMIN_CHAT_SETTINGS_NOTIFICATIONS': '/admin/chats/settings/notifications',
    'VTB_SERVICES': '/vtb/services',
    'VTB_EDUCATION': '/vtb/education',
    'VTB_CONTACTS': '/vtb/contacts',
    'VTB_EVENTS': '/vtb/events',
    'VTB_EARNINGS': '/vtb/earnings',
    'VTB_CAREER': '/vtb/career',
    'PRICING': 'https://volee.co/price',
    'PRIVATE_POLICY': 'https://policy.volee.space/docs/policy_ru.html',
    'PRIVATE_POLICY_EN': 'https://policy.volee.co/docs/policy_en.html',
    'PRIVATE_POLICY_JO': 'https://policy.joinee.io/docs/policy_jo.html',
    'PRIVATE_POLICY_ANNAMONEY': 'https://policy.volee.co/docs/policy_annamoney.html',
    'TERMS_OF_USE': 'https://policy.volee.space/docs/terms_ru.html',
    'TERMS_OF_USE_EN': 'https://policy.volee.co/docs/terms_en.html',
    'TERMS_OF_USE_JO': 'https://policy.joinee.io/docs/terms_jo.html',
    'AGREEMENT_RU': '/docs/agreement_ru.html',
    'AGREEMENT_NW': '/docs/agreement_nw.html',
}

/** @param {string} [section] */
export const adminChatSettingsPath = (section) =>
    `${PAGES.ADMIN_CHAT_SETTINGS}/${section || 'scenarios'}`;

export const eventNotificationsPath = (eventId) => `/event/${eventId}/notifications`;

export const eventDetailPath = (eventId) => `/event/${eventId}`;

export const eventLivePath = (eventId) => `/event/${eventId}/live`;

export const eventLiveManagePath = (eventId) => `/event/${eventId}/live/manage`;

export const eventLivePresentPath = (eventId) => `/event/${eventId}/live/present`;

/** @param {string} slug */
export const jobDetailPath = (slug) => `/job/${slug}`;

/** @param {string} slug */
export const jobApplyPath = (slug) => `/job/${slug}/apply`;

/** @param {string} slug */
export const jobQuestionsPath = (slug) => `/job/${slug}/questions`;

/** @param {string} slug */
export const jobApplicationsPath = (slug) => `/jobs/${slug}/applications`;

/** @param {string} slug @param {string|number} applicationId */
export const jobApplicationDetailsPath = (slug, applicationId) =>
    `/jobs/${slug}/applications/${applicationId}`;
